import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import axios from 'axios';

let env = process.env.REACT_APP_API_BASE_URL;

const requestInstance = axios.create({
  baseURL: env,
});

export const rideDetailsPolyLines = async (data) => {
    let url = `${env}${API_ENDPOINT.liveTrips.api}/${data}`;
    const res = await requestInstance.get(url).catch((err) => err.response);
    return setCurrentUser(res);
  };